interface IYouTubeAnalysisVideoProps {
  analysisVideo: string;
}

export default function YouTubeAnalysisVideo({ analysisVideo }: IYouTubeAnalysisVideoProps) {
  const videoId = getYouTubeVideoId(analysisVideo);

  if (!videoId) {
    return null;
  }

  return (
    <div
      css={{
        display: "grid",
        gridColumnGap: 30,
        gridTemplateColumns: "repeat(12, 1fr)",
        alignItems: "center",
        width: 1140,
        margin: "0px auto",
      }}
    >
      <div
        css={{
          gridColumn: "3 / span 8",
          paddingTop: 48,
          paddingBottom: 48,
        }}
      >
        <div
          style={{
            position: "relative",
            height: 0,
            /* 16:9 */
            paddingTop: 25,
            paddingBottom: "56.25%",
            borderRadius: 8,
            boxShadow: "0 10px 24px 0 #33333333",
          }}
        >
          <iframe
            title="foo"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              borderRadius: 8,
            }}
            allowFullScreen={true}
            src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0`}
            frameBorder="0"
          />
        </div>
      </div>
    </div>
  );
}

function getYouTubeVideoId(url: string): string | null {
  const matches = (url || "").match(
    /(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^/&]{10,12})/,
  );

  return matches && matches[1] ? matches[1] : null;
}
